const ordersData = [
    {
        orderid: '#NZ1563',
        date: '28 Mar, 2020',
        billingname: 'Frank Dean',
        total: '$164',
        paymentstatus: 'Unpaid'
    },
    {
        orderid: '#NZ1564',
        date: '28 Mar, 2020',
        billingname: 'Eddy Torres',
        total: '$141',
        paymentstatus: 'Paid'
    },
    {
        orderid: '#NZ1565',
        date: '29 Mar, 2020',
        billingname: 'Jamison Clark',
        total: '$123',
        paymentstatus: 'Paid'
    },
    {
        orderid: '#NZ1566',
        date: '30 Mar, 2020',
        billingname: 'Jewel Buckley',
        total: '$112',
        paymentstatus: 'Paid'
    },
    {
        orderid: '#NZ1567',
        date: '31 Mar, 2020',
        billingname: 'Jeffrey Waltz',
        total: '$105',
        paymentstatus: 'Unpaid'
    },
    {
        orderid: '#NZ1568',
        date: '01 Apr, 2020',
        billingname: 'Jefferson Allen',
        total: '$160',
        paymentstatus: 'Chargeback'
    },
    {
        orderid: '#NZ1569',
        date: '02 Apr, 2020',
        billingname: 'Paul Jones',
        total: '$183',
        paymentstatus: 'Paid'
    },
    {
        orderid: '#NZ1570',
        date: '03 Apr, 2020',
        billingname: 'Donald Bailey',
        total: '$146',
        paymentstatus: 'Paid'
    },
    {
        orderid: '#NZ1571',
        date: '03 Apr, 2020',
        billingname: 'Jimmy Barker',
        total: '$165',
        paymentstatus: 'Unpaid'
    },
    {
        orderid: '#NZ1572',
        date: '04 Apr, 2020',
        billingname: 'Walter Brown',
        total: '$172',
        paymentstatus: 'Paid'
    },
    {
        orderid: '#NZ1573',
        date: '06 Apr, 2020',
        billingname: 'James Hamilton',
        total: '$152',
        paymentstatus: 'Paid'
    },
    {
        orderid: '#NZ1574',
        date: '08 Apr, 2020',
        billingname: 'Smith Velly',
        total: '$158',
        paymentstatus: 'Unpaid'
    }
];

export { ordersData };
